var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "edit-dialog custom-dialog-min-width",
          attrs: {
            title: "乐播榜媒资导入",
            visible: _vm.dialogVisible,
            width: "50%",
            "modal-append-to-body": true,
            "append-to-body": "",
            "close-on-click-modal": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c("div", { staticClass: "search-container" }, [
            _c(
              "div",
              [
                _c("el-input", {
                  staticStyle: { width: "120px", "margin-right": "10px" },
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "媒资名称",
                  },
                  model: {
                    value: _vm.searchParams.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParams, "name", $$v)
                    },
                    expression: "searchParams.name",
                  },
                }),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "120px", "margin-right": "10px" },
                    attrs: {
                      size: "small",
                      clearable: "",
                      placeholder: "媒资类型",
                    },
                    model: {
                      value: _vm.searchParams.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "type", $$v)
                      },
                      expression: "searchParams.type",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "电视剧", value: 1 } }),
                    _c("el-option", { attrs: { label: "电影", value: 2 } }),
                    _c("el-option", { attrs: { label: "综艺", value: 3 } }),
                    _c("el-option", { attrs: { label: "少儿", value: 4 } }),
                  ],
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "120px", "margin-right": "10px" },
                    attrs: {
                      size: "small",
                      clearable: "",
                      placeholder: "状态",
                    },
                    model: {
                      value: _vm.searchParams.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "status", $$v)
                      },
                      expression: "searchParams.status",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "上架", value: 1 } }),
                    _c("el-option", { attrs: { label: "下架", value: 0 } }),
                  ],
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "120px", "margin-right": "10px" },
                    attrs: {
                      size: "small",
                      clearable: "",
                      placeholder: "来源",
                    },
                    model: {
                      value: _vm.searchParams.sourceType,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "sourceType", $$v)
                      },
                      expression: "searchParams.sourceType",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "腾讯资源", value: 1 } }),
                    _c("el-option", { attrs: { label: "优酷资源", value: 2 } }),
                    _c("el-option", {
                      attrs: { label: "爱奇艺资源", value: 3 },
                    }),
                    _c("el-option", { attrs: { label: "Bilibili", value: 8 } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.search },
                  },
                  [_vm._v("搜索")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              ref: "table",
              staticStyle: { "margin-top": "20px" },
              attrs: {
                data: _vm.list,
                "tooltip-effect": "dark",
                height: "470",
                "row-key": "id",
              },
              on: { select: _vm.selectionChange, "select-all": _vm.selectAll },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { "show-overflow-tooltip": "", label: "ID", prop: "id" },
              }),
              _c("el-table-column", {
                attrs: { label: "媒资图片", prop: "coverImage" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.ifShowIframe
                          ? _c("ImageIframe", {
                              staticStyle: { width: "75px", height: "70px" },
                              attrs: { url: scope.row.coverImage },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: "媒资名称",
                  prop: "name",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "媒资类型", prop: "type" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type === 1
                          ? _c("span", [_vm._v("电视剧")])
                          : scope.row.type === 2
                          ? _c("span", [_vm._v("电影")])
                          : scope.row.type === 3
                          ? _c("span", [_vm._v("综艺")])
                          : scope.row.type === 4
                          ? _c("span", [_vm._v("少儿")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "播放来源", prop: "sourceType" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.sourceType === 1
                          ? _c("span", [_vm._v("腾讯资源")])
                          : scope.row.sourceType === 2
                          ? _c("span", [_vm._v("优酷资源")])
                          : scope.row.sourceType === 3
                          ? _c("span", [_vm._v("爱奇艺资源")])
                          : scope.row.sourceType === 8
                          ? _c("span", [_vm._v("Bilibili")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", prop: "status" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 1
                          ? _c("span", [_vm._v("上架")])
                          : scope.row.status === 0
                          ? _c("span", [_vm._v("下架")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: "媒资标签",
                  prop: "tagName",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "最后更新时间", prop: "updateTime" },
              }),
            ],
            1
          ),
          _c(
            "el-popover",
            {
              attrs: { placement: "top-start", width: "400", trigger: "click" },
            },
            [
              _c("div", [_vm._v("已选记录列表")]),
              _c("div", [
                _vm._v("已选择 ( " + _vm._s(_vm.selectedCount) + " ) "),
                _c(
                  "span",
                  { staticClass: "all-option", on: { click: _vm.clearAll } },
                  [_vm._v(" 全部移除")]
                ),
              ]),
              _c(
                "el-table",
                { attrs: { data: _vm.selectedList } },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      label: "ID",
                      prop: "id",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "媒资图片", prop: "coverImage" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.ifShowIframe
                              ? _c("ImageIframe", {
                                  staticStyle: {
                                    width: "75px",
                                    height: "70px",
                                  },
                                  attrs: { url: scope.row.coverImage },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      label: "媒资名称",
                      prop: "name",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "媒资类型", prop: "type" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.type === 1
                              ? _c("span", [_vm._v("电视剧")])
                              : scope.row.type === 2
                              ? _c("span", [_vm._v("电影")])
                              : scope.row.type === 3
                              ? _c("span", [_vm._v("综艺")])
                              : scope.row.type === 4
                              ? _c("span", [_vm._v("少儿")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      label: "播放来源",
                      prop: "sourceType",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.sourceType === 1
                              ? _c("span", [_vm._v("腾讯资源")])
                              : scope.row.sourceType === 2
                              ? _c("span", [_vm._v("优酷资源")])
                              : scope.row.sourceType === 3
                              ? _c("span", [_vm._v("爱奇艺资源")])
                              : scope.row.sourceType === 8
                              ? _c("span", [_vm._v("Bilibili")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", prop: "status" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status === 1
                              ? _c("span", [_vm._v("上架")])
                              : scope.row.status === 0
                              ? _c("span", [_vm._v("下架")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      label: "媒资标签",
                      prop: "tagName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      label: "最后更新时间",
                      prop: "updateTime",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.remove(scope.row)
                                  },
                                },
                              },
                              [_vm._v("移除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("div", { attrs: { slot: "reference" }, slot: "reference" }, [
                _vm._v("\n        已选择 ( "),
                _c("span", { staticClass: "select-count" }, [
                  _vm._v(_vm._s(_vm.selectedCount)),
                ]),
                _vm._v(" )\n      "),
              ]),
            ],
            1
          ),
          _c("ElementPagination", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              "current-page": _vm.searchParams.current,
              "page-size": _vm.searchParams.size,
              total: _vm.searchParams.total,
              "page-sizes": [10, 20, 30, 40, 50],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.hide } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.save },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入确认",
            visible: _vm.importVisible,
            width: "40%",
            "modal-append-to-body": true,
            "append-to-body": "",
            "close-on-click-modal": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.importVisible = $event
            },
            closed: _vm.importHide,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
                "flex-direction": "column",
              },
            },
            [
              _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                _vm._v(
                  "已选择媒资" +
                    _vm._s(_vm.selectedCount) +
                    "个，重复媒资" +
                    _vm._s(_vm.repeatRes) +
                    "个"
                ),
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.submitImport },
                },
                [_vm._v("确认导入")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }